/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, IconButton, Switch, Button } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import SearchBar from "../../components/SearchBar";
import { useEffect, useState } from "react";
import { useDeleteRoleByIdMutation, useLazyGetAllRolesQuery, useUpdateRoleByIdMutation } from "../../services/accessRole";
import { showError, showToast } from "../../constants/toasts";
import { ConfirmationModal } from "../../Modals/ConfirmationModal";
import CustomToggle from "../../helpers/CustomToggle";
import { isValidInput } from "../../utils/validations";
const RolesList = () => {

    const navigate = useNavigate();
    const [getRoles] = useLazyGetAllRolesQuery()
    const label = { inputProps: { 'aria-label': 'Switch demo' } };
    const [roleData, setRoleData] = useState<any[]>([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [deleteRole] = useDeleteRoleByIdMutation();
    const [selectedId, setSelectedId] = useState("");
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [statusUpdate] = useUpdateRoleByIdMutation()
    const formatDate = (iso?: string) => (iso ? new Date(iso).toLocaleDateString() : "-");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");

    const fetchRoles = async () => {
        setLoading(true)
        try {
            const response = await getRoles({
                from: page,
                size: pageSize,
                search: debouncedSearchTerm,
            }).unwrap();

            if (response?.statusCode === 200) {
                setRoleData(response.data.data || []);
                setTotalCount(response.data.total || 0);
            }
        } catch (error: any) {
            showError(error?.data?.message || "Failed to fetch roles");
        }
        finally {
            setLoading(false)
        }
    };

    const deleteBannerApi = async (id: string) => {
        setLoading(true);
        try {
            const response = await deleteRole({
                id: selectedId,
            }).unwrap();
            setLoading(false);
            if (response?.statusCode === 200) {
                showToast(response?.message || "Role Deleted Successfully");
                fetchRoles();
            }
        } catch (error: any) {
            showError(error?.data?.message || "");
            setLoading(false);
        }
    };
    const toggleStatus = async (id: string, currentStatus: boolean) => {
        try {
            const response = await statusUpdate({
                id,
                body: { isBlocked: !currentStatus },
            }).unwrap();

            if (response?.statusCode === 200) {
                showToast(
                    `Role ${!currentStatus ? " deactivated" : "activated"} successfully`
                );
                fetchRoles();
            } else {
                showError("Failed to update Role status");
            }
        } catch (error: any) {
            showError(error?.data?.message || "Failed to update Role status");
        }
    };
    useEffect(() => {
        fetchRoles()
    }, [page, pageSize, debouncedSearchTerm])
    const handlePageChange = (_: any, newPage: number) => {
        setPage(newPage)
    }
    const rows = roleData.map((role: any, index: number) => ({
        id: role?._id || index,
        name: role?.name || "-",
        date: formatDate(role?.createdAt),
        isBlocked: !!role?.isBlocked,
    }));
    const columns: GridColDef<any>[] = [
        {
            flex: 2,
            minWidth: 180,
            field: "name",
            headerName: "Role Name",
            editable: false,
            sortable: false,
            renderCell: (params) => {
                return (
                    <div className="user_block click_action" onClick={() => navigate(`/manage-subadmin/roles/detail/${params?.row?.id}`)}>
                        <p><b>{params?.row?.name || '-'}</b></p>
                    </div>
                )
            }
        },
        {
            flex: 1,
            minWidth: 150,
            field: "date",
            headerName: "Created Date",
            editable: false,
            sortable: false,
        },
        {
            flex: 1,
            minWidth: 100,
            field: "isBlocked",
            headerName: "Status",
            editable: false,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                return (
                    <CustomToggle
                        checked={!params.value}
                        onChange={() => toggleStatus(params.row.id, params.value)}
                        id={params.row.id}
                    />
                )
            }
        },
        {
            minWidth: 130,
            field: "action",
            headerName: "Action",
            editable: false,
            sortable: false,
            renderCell: ({ row }) => {
                return (
                    <div className="table_actions v2">
                        <Box>
                            <IconButton onClick={() => navigate(`/manage-subadmin/roles/detail/${row?.id}`)}>
                                <img src="/static/images/eye_icon.svg" alt="" />
                            </IconButton>
                        </Box>
                        <Box>
                            <IconButton onClick={() => navigate(`/manage-subadmin/roles/edit/${row?.id}`)}>
                                <img src="/static/images/edit2_icon.svg" alt="" />
                            </IconButton>
                        </Box>
                        <Box>
                            <IconButton onClick={() => {
                                setSelectedId(row?.id)
                                setOpen(true)
                            }}>
                                <img src="/static/images/trash2_icon.svg" alt="" />
                            </IconButton>
                        </Box>
                    </div>
                )
            }
        }
    ];
    let hidden = ["fullName"];

    return (
        <>
            <div className="table_header">
                <div className="left_s">
                    <Box className="search_box">
                        <SearchBar
                            placeholder="Search..."
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setDebouncedSearchTerm}
                            value={searchTerm}
                            onCross={() => setSearchTerm("")}
                            onChange={(val: any) => {
                                if (isValidInput(val.target.value)) {
                                    setSearchTerm(val.target.value);
                                }
                            }}
                        />
                    </Box>
                </div>
                <div className="right_s">
                    <Button className="btn btn_primary" onClick={() => navigate("/manage-subadmin/roles/add")}><AddIcon /> Add Role</Button>
                </div>
            </div>
            <div className="sorting_table">
                <TableComponent
                    columns={columns?.filter((item) => !hidden.includes(item.field))}
                    rows={rows}
                    count={totalCount}
                    page={page}
                    onPageChange={handlePageChange}
                    loading={loading}
                    getRowId={(row: any) => row.id}
                />
                <ConfirmationModal
                    text={"Are you sure you want to delete this Role?"}
                    openModal={open}
                    setOpenModal={setOpen}
                    handleSubmit={() => deleteBannerApi(selectedId)}
                />
            </div>
        </>
    );
};

export default RolesList;
